// @flow

import {
  Elastic_SEARCH_REQUEST,
  Elastic_SEARCH_REQUESTED,
  Elastic_SEARCH_REQUEST_Error
} from './constants';

import type { Action, ElasticSearch } from '../types';

export const requestElasticSearch = (
  requestPayload: {
    query?: string
  } = {}
): Action => ({
  type: Elastic_SEARCH_REQUEST,
  requestPayload
});

export const updateElasticSearch = (data: Array<ElasticSearch>): Action => ({
  type: Elastic_SEARCH_REQUESTED,
  data
});

export const errorElasticSearch = (error: Error): Action => ({
  type: Elastic_SEARCH_REQUEST_Error,
  error
});
